import type { ReactElement } from 'react'
import { useDroppable } from '@dnd-kit/core'
import { Ban } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface CostNotNeededDropZoneProps {
  isDragActive: boolean
}

export function CostNotNeededDropZone({
  isDragActive,
}: CostNotNeededDropZoneProps): ReactElement {
  const { t } = useTranslation('features-indirect-costs')
  const { isOver, setNodeRef } = useDroppable({
    id: 'cost-not-needed',
    data: { type: 'cost-not-needed' },
  })

  return (
    <div
      ref={setNodeRef}
      className={cn(
        'flex items-center gap-3 rounded-xl px-4 py-3 transition-all outline-dashed outline-1 -outline-offset-1',
        isOver
          ? 'outline-2 outline-primary/50 bg-primary/8 scale-[1.01]'
          : isDragActive
            ? 'outline-zinc-500'
            : 'outline-zinc-600',
      )}
    >
      <Ban className="size-4 shrink-0 text-muted-foreground/60" />
      <span className="text-sm text-muted-foreground/70">
        {t('kanban.dropCostNotNeeded', { defaultValue: 'Drop a payment that doesn\u2019t need cost linking' })}
      </span>
    </div>
  )
}
